export enum LicenseStatus {
  not_available = 'not_available',
  available = 'available',
  reserved = 'reserved',
}
